import { WorkCaseStatuses, type WorkActionProjection } from '@myfm/domain';

export function currentWorkActions(value: unknown, version: number, stage: string): WorkActionProjection | null {
  if (!value || typeof value !== 'object') return null;
  const p=value as WorkActionProjection;
  if (p.evaluatedVersion!==version || !Number.isSafeInteger(version) || version<1 || p.stage!==stage ||
    !['available','blocked','unavailable','not-evaluated'].includes(p.dependencyState) || !Array.isArray(p.availableActions) || !Array.isArray(p.blockedActions)) return null;
  const all=[...p.availableActions,...p.blockedActions],seen=new Set<string>();
  for(const action of all){
    if(!action || typeof action.id!=='string' || seen.has(action.id) || typeof action.label!=='string' || typeof action.effect!=='string' ||
      !['record-edit','governed-workflow','navigation'].includes(action.kind) || !Array.isArray(action.prerequisites) ||
      action.prerequisites.some(item=>!item || typeof item.code!=='string' || typeof item.message!=='string')) return null;
    seen.add(action.id);
    if(action.id.startsWith('stage:')){
      if(!action.target || !Object.values(WorkCaseStatuses).includes(action.target) || action.id!==`stage:${action.target}` || action.kind!=='record-edit') return null;
    }else if(({ 'save-draft':'record-edit','review-procurement':'navigation','record-inspection':'governed-workflow' } as Record<string,string>)[action.id]!==action.kind || action.target!==undefined) return null;
  }
  if(p.availableActions.some(action=>action.prerequisites.length) || p.blockedActions.some(action=>!action.prerequisites.length) ||
    (p.primaryActionId!==null&&!seen.has(p.primaryActionId)) || (p.recordStageActionId!==null&&!all.some(action=>action.id===p.recordStageActionId&&action.target)))return null;
  return p;
}
